import { Controller } from "@hotwired/stimulus"

// allows quickly submitting the connected textarea's form using cmd+enter
export default class extends Controller {
  connect() {
    this.element.addEventListener('keydown', function(e) {
      if(e.keyCode == 13 && e.metaKey) {
        this.form.requestSubmit();
      }
    });
  }
}
